/**
 * @module app.prospection.store.reminderCtrl
 */

define(['angular', 'moment'], function(angular, moment) {

    function ReminderCtrl($scope, $rootScope, $filter, $log, $window, $timeout, appointmentService, appointmentFiltersService, userService,
        commonService, fournisseurService, Notification, leafletMapEvents) {
        let self = this;
        const DEFAULT_ZOOM_LEVEL = 9;
        self.commonService = commonService;
        self.appointments = [];
        self.error = {};
        self.purposes = [];
        self.teleproPurpose = [];
        self.csdPurpose = [];
        self.loading = false;
        self.isOtherAppointments = true;
        self.isOtherAppointmentsLoading = false;
        self.showSidebar = false;
        self.showRds = false;
        self.showTelepro = false;
        self.showCs = false;
        self.showCsd = false;
        self.showFormerRDS = false;
        self.displayMap = $rootScope.user.role === 'RDS';
        self.center = {};
        self.markers = {};
        self.networkList = [
            {id: '300', label: 'Bimedia'},
            {id: '302', label: 'Devlyx'},
            {id: '304', label: 'Futurosoft'},
            {id: '003', label: 'NAP'}
        ];

        self.marketsList = [
            {id: '001', label: 'Tabac Presse'},
            {id: '002', label: 'Boulangerie'},
            {id: '003', label: 'Autres'},
            {id: '011', label: 'Fleuriste'},
            {id: '012', label: 'Restauration'},
            {id: '014', label: 'Bar'}
        ];

        self.stateOptions = [
            { id: 'EAIN', label: 'Pré-client', code: 'pre-client', icon: 'fa-check', color: '#5bc0de', class: 'state_0' },
            { id: 'INST', label: 'Client', code: 'client', icon: 'fa-check-circle-o', color: '#b9d4ec', class: 'state_1' },
            { id: 'RESI', label: 'Ancien client', code: 'ancien-client', icon: 'fa-close', color: '#f0ad4e', class: 'state_2' },
            { id: 'EATC', label: 'Prospect', code: 'prospect', icon: 'fa-circle-o', color: '#c7e6c7', class: 'state_3' },
            { id: 'ANPR', label: 'Ancien Propriétaire', code: 'ancien-proprietaire', icon: 'fa-circle-o', color: '#d9534f', class: 'state_4' },
            { id: 'EARP', label: 'Attente Reprise', code: 'attente-reprise', icon: 'fa-circle-o', color: '#777777', class: 'state_5' }
        ];

        self.legend = {
            position: 'bottomleft',
                colors: [ '#5bc0de', '#b9d4ec', '#f0ad4e', '#c7e6c7', '#d9534f', '#777777'],
                labels: [ 'Pré-client', 'Client', 'Ancien client', 'Prospect', 'Ancien Propriétaire', 'Attente Reprise']
        };


        self.treated = [
            {id: '0', label: 'A traiter'},
            {id: '1', label: 'Traité'}
        ];

        self.fournisseurs = fournisseurService.list();

        self.marketOptions = [
            { state: '001', label: 'Tabac Presse', code: 'tabacpresse' },
            { state: '002', label: 'Boulangerie', code: 'boulangerie' },
            { state: '003', label: 'Autres PDV', code: 'autre' },
            { state: '011', label: 'Fleuriste', code: 'fleuriste' },
            { state: '012', label: 'Restauration', code: 'restauration' },
            { state: '014', label: 'Bar', code: 'bar'}
        ];

        self.getState = (state) => {
            return self.stateOptions.find(stateOption => stateOption.id === state) ? self.stateOptions.find(stateOption => stateOption.id === state).label : '';
        }

        self.getDisplayName = function (uid){
            const user =  userService.findPerson(uid);
            return user ? user.user.displayName : uid;
        }

        self.updateAppointmentStatus = function(appointment) {
           return appointmentService.updateAppointmentStatus(appointment).catch(function(err) {Notification.error(err.message);});
        }
        /* =========================================================================================== */
        /*                                        FILTERS                                              */
        /* =========================================================================================== */

        let _filters = {
            rds: [],
            telepro: [],
            cs: [],
            csd: [],
            formerRDS: [],
            offset: 0,
            limit: 50
        };

        /* Date updated filter */
        self.dateStartFilterOptions = appointmentFiltersService.dateUpdatedOptions;
        self.dateEndFilterOptions = appointmentFiltersService.dateUpdatedOptions;

        self.isOpenedDateStartFilter = false;
        self.isOpenedDateEndFilter = false;

        self.toggleDateStartFilter = function () {
            self.isOpenedDateStartFilter = appointmentFiltersService.toggle(self.isOpenedDateStartFilter);
        };

        self.toggleDateEndFilter = function () {
            self.isOpenedDateEndFilter = appointmentFiltersService.toggle(self.isOpenedDateEndFilter);
        };

        self.formatDate = (data, type, lang) => {
            lang = typeof lang !== 'undefined' ? lang : 'en';
            const format = {
                en:{
                    full : data !== null ? moment(data).format('YYYY-MM-DD') : null,
                    month : data !== null ? moment(data).format('YYYY-MM') : null,
                },
                fr:{
                    full : data !== null ? moment(data).format('DD/MM/YYYY') : null,
                    month : data !== null ? moment(data).format('MM/YYYY') : null,
                }
            }
            return format[lang][type];
        }

        /**
         * Apply selected filter values
         */
        self.applyFilter = function () {
            self.showSidebar = false;
            if (
                self.departmentFilter !== null &&
                self.departmentFilter.trim() !== '' &&
                !Number.isInteger(parseInt(self.departmentFilter))
            ) {
                Notification.error("<b>Erreur sur le département : </b> ce n'est pas un nombre");
                return;
            }
            if (
                self.dateEndFilter !== null &&
                commonService.checkDateRange(self.dateStartFilter, self.dateEndFilter) === false
            ) {
                Notification.error(
                    '<b>Erreur sur la période du filtre:</b> date de modification de début avant celle de fin'
                );
                return;
            }

            // Map present filters in the controller to build an array with their values
            var filtersToSave = appointmentFiltersService.filtersList.map(function(key) {
                return self[key];
            });
            // Save builts array with filters values
            appointmentFiltersService.saveFilters(filtersToSave);
            _filters.dateStart = appointmentFiltersService.applyFullDateFilter(self.dateStartFilter);
            _filters.dateEnd = appointmentFiltersService.applyFullDateFilter(self.dateEndFilter);

            _updateAppointmentsList();
        };

        $scope.$watch('reminderCtrl.clientFilter', function(newValue, oldValue) {
            if (oldValue == '') {
                return;
            }
            _filters.client = null;

            if (newValue != '') {
                _filters.client = newValue;
            }
        });

        $scope.$watch('reminderCtrl.departmentFilter', function(newValue, oldValue) {
            if (oldValue == '') {
                return;
            }
            _filters.department = null;

            if (newValue != '') {
                _filters.department = newValue;
            }
        });

        $scope.$watchCollection('reminderCtrl.networkFilter', function(newValue, oldValue) {
            if (!oldValue ||  oldValue.length === 0) {
                return;
            }
            _filters.network = appointmentFiltersService.applyFilter(self.networkFilter, 'network');

            if (!oldValue[0] && newValue[0]) {
                self.networkFilter = [true, false, false, false];
            }

            if (!oldValue[1] && newValue[1]) {
                self.networkFilter = [false, true, false, false];
            }

            if (!oldValue[2] && newValue[2]) {
                self.networkFilter = [false, false, true, false];
            }

            if (!oldValue[3] && newValue[3]) {
                self.networkFilter = [false, false, false, true];
            }
        });

        $scope.$watchCollection('reminderCtrl.treatedFilter', function(newValue, oldValue) {
            if (!oldValue ||  oldValue.length === 0) {
                return;
            }
            _filters.treated = appointmentFiltersService.applyFilter(self.treatedFilter, 'treated');

            if (!oldValue[0] && newValue[0]) {
                self.treatedFilter = [true, false];
            }

            if (!oldValue[1] && newValue[1]) {
                self.treatedFilter = [false, true];
            }
        });

        $scope.$watch('reminderCtrl.dateStartFilter', function(newValue, oldValue) {
            if (oldValue == '') {
                return;
            }
            if (newValue === null) {
                _filters.dateEnd = newValue;
                self.dateEndFilter = newValue
            }
        });

        /**
         *  update filters.market with id from marketsList according to checked filters
         */
        self.updateMarketFilter = function () {
            var marketCodes = self.marketsList.map(function(market) {
                // get code
                return market.id;
            });
            _filters.market = appointmentFiltersService.applyMultipleFilterValues(self.marketFilter, marketCodes);
        }

        self.updatePurposeFilter = () => {
            let purposeCodes = self.purposes.map(purpose => purpose.id);
            _filters.purpose = appointmentFiltersService.applyMultipleFilterValues(self.purposeFilter, purposeCodes);
        }

        self.updateStateFilter = () => {
            let stateCodes = self.stateOptions.map(state => state.id);
            _filters.state = appointmentFiltersService.applyMultipleFilterValues(self.stateFilter, stateCodes);
        }

        self.updateSupplierFilter = () => {
            let suppliersCodes = self.fournisseurs.map(f => f.id);
            _filters.supplier = appointmentFiltersService.applyMultipleFilterValues(self.supplierFilter, suppliersCodes);
        }


        /**
         * Watch rds filter input to construct filter value
         */
        self.updateRDSFilter = function () {
            var selectedRDS = $filter('filter')(self.userNetwork.rdsReminder, { checked: true });
            _filters.rds = [];

            for (var i = 0; i < selectedRDS.length; i++) {
                _filters.rds.push(selectedRDS[i].user.uid);
            }
        };

        self.updateTeleproFilter = function () {
            var selectedTelepro = $filter('filter')(self.userNetwork.teleproReminder, { checked: true });
            _filters.telepro = [];
            for (var i = 0; i < selectedTelepro.length; i++) {
                _filters.telepro.push(selectedTelepro[i].user.uid);
            }
        };

        self.updateCsFilter = function () {
            var selectedCs = $filter('filter')(self.userNetwork.csReminder, { checked: true });
            _filters.cs = [];

            for (var i = 0; i < selectedCs.length; i++) {
                _filters.cs.push(selectedCs[i].user.uid);
            }
        };

        self.updateCsdFilter = function () {
            var selectedCsd = $filter('filter')(self.userNetwork.csdReminder, { checked: true });
            _filters.csd = [];

            for (var i = 0; i < selectedCsd.length; i++) {
                _filters.csd.push(selectedCsd[i].user.uid);
            }
        };

        self.updateFormerRDSFilter = function () {
            var selectedRDS = $filter('filter')(self.userNetwork.formerRDSReminder, { checked: true });
            _filters.formerRDS = [];

            for (var i = 0; i < selectedRDS.length; i++) {
                _filters.formerRDS.push(selectedRDS[i].user.uid);
            }
        };

        /**
         * Reset filters
         */
        self.clearFilters = function clearFilters() {
            appointmentFiltersService.clearFilters();

            _initIHMFilters();
            self.dateStartFilter = moment().isoWeekday(1).toDate();
            self.dateEndFilter = moment().endOf('week').add(1,'day').toDate();
            _filters.dateStart = appointmentFiltersService.applyFullDateFilter(self.dateStartFilter);
            _filters.dateEnd = appointmentFiltersService.applyFullDateFilter(self.dateEndFilter);
            self.treatedFilter = [true, false];
            _filters.treated = appointmentFiltersService.applyFilter(self.treatedFilter, 'treated');

            _filters.rds = _generateRDSFilter();
            _filters.telepro = [];
            _filters.cs = [];
            _filters.csd = [];
            _filters.formerRDS = [];
            _filters.market = [];
            _filters.purpose = _genereratePurposeFilter();
            _filters.network = [];
            _filters.state = [];
            _filters.supplier = [];
            _filters.offset = 0;

            _initFiltersValues();

            self.userNetwork.rdsReminder.forEach(function(rds) {
                rds.checked = false;
            });

            self.userNetwork.teleproReminder.forEach(function(telepro) {
                telepro.checked = telepro.user.uid === self.user.uid;
            });

            self.userNetwork.csReminder.forEach(function(cs) {
                cs.checked = cs.user.uid === self.user.uid;
            });

            self.userNetwork.csdReminder.forEach(function(csd) {
                csd.checked = csd.user.uid === self.user.uid;
            });

            self.userNetwork.formerRDSReminder.forEach(function(formerRDS) {
                formerRDS.checked = false;
            });

            self.rdsFilter = _generateRDSFilterForIHM();
            self.updateCsFilter();
            self.updateCsdFilter();
            self.updateTeleproFilter();
            self.updatePurposeFilter();
            _updateAppointmentsList()
        };

        function _updateAppointmentsList(append) {
            self.loading = true;
            appointmentService.getAllAppointments(_filters)
                .then(function(appointments) {
                    if (append) {
                        self.appointments = self.appointments.concat(appointments);
                    } else {
                        self.appointments = appointments;
                    }
                    if (appointments.length < _filters.limit) {
                        self.isOtherAppointments = false;
                    }else{
                        self.isOtherAppointments = true;
                    }
                    _setMarkers(self.appointments, true)
                })
                .catch(function(err) {
                    $log.error(err);
                    self.appointments = [];
                })
                .finally(function() {
                    self.isOtherAppointmentsLoading = false;
                    self.loading = false;
                });
        }


        /**
         * Generate the values for the rds filter at the clear or loading action
         * @return {Array}
         */
        function _generateRDSFilter() {
            return self.userNetwork.rdsReminder.length === 0 && self.user.role === 'RDS' ? [self.user.uid] : [];
        }

        function _genereratePurposeFilter() {
            let purposes = []
            if(self.user.role === 'RDS' && !appointmentFiltersService.saved){
                const PP = self.purposes.find(purpose => purpose.label  === 'Contact non abouti - PP à faire')
                if(PP)
                    purposes.push(PP.id);
            }
            return purposes;
        }

        /**
         * Generate the RDS filter options list
         * @param  {Array} parents
         * @return {Array}
         */
        function _generateRDSFilterForIHM(parents) {
            if (!parents || !parents.length) {
                return self.userNetwork.rdsReminder.length > 0 ? self.userNetwork.rdsReminder : [self.user.uid];
            }

            let rds = [];
            for (let i = 0; i < parents.length; i++) {
                for (let j = 0; j < self.userNetwork.rdsReminder.length; j++) {
                    if (parents[i].user.uid === self.userNetwork.rdsReminder[j].parent) {
                        rds.push(self.userNetwork.rdsReminder[j]);
                    }
                }
            }
            return rds;
        }

        /**
         * Apply default filters Values to IHM
         */
        function _initIHMFilters() {
            if (appointmentFiltersService.saved) {
                appointmentFiltersService.filtersList.forEach(function(key, index) {
                    self[key] = appointmentFiltersService.getFilters()[index]; // assign saved filter values
                });
            }
            else {
                self.networkFilter = appointmentFiltersService.getDefaultFilter('boolean', 4);
                // self.treatedFilter = appointmentFiltersService.getDefaultFilter('boolean', 2);
                self.treatedFilter = [true, false];
                self.marketFilter = appointmentFiltersService.getDefaultFilter('boolean', 6);
                self.purposeFilter = appointmentFiltersService.getDefaultFilter('boolean', 4);
                self.stateFilter = appointmentFiltersService.getDefaultFilter('boolean', 6);
                self.supplierFilter = appointmentFiltersService.getDefaultFilter('boolean', 22);
                if($rootScope.user.role === 'RDS') self.purposeFilter[2] = true;
                self.clientFilter = appointmentFiltersService.getDefaultFilter('string');
                self.dateStartFilter = appointmentFiltersService.getDefaultFilter('date');
                self.dateEndFilter = appointmentFiltersService.getDefaultFilter('date');
                self.departmentFilter = appointmentFiltersService.getDefaultFilter('integer');
                self.dateStartFilter = moment().isoWeekday(1).toDate();
                self.dateEndFilter = moment().endOf('week').add(1,'day').toDate();
            }
        }

        function _initFiltersValues() {
            _filters.network = appointmentFiltersService.applyFilter(self.networkFilter, 'network');
            _filters.treated = appointmentFiltersService.applyFilter(self.treatedFilter, 'treated');
            _filters.market = appointmentFiltersService.applyMultipleFilterValues(self.marketFilter, self.marketsList.map(function(market) { return market.id; }));
            _filters.purpose = appointmentFiltersService.applyMultipleFilterValues(self.purposeFilter, self.purposes.map(function(purpose) { return purpose.id; }));
            _filters.state = appointmentFiltersService.applyMultipleFilterValues(self.stateFilter, self.stateOptions.map(function(state) { return state.id; }));
            _filters.supplier = appointmentFiltersService.applyMultipleFilterValues(self.supplierFilter, self.fournisseurs.map(function(supplier) { return supplier.id; }));
            _filters.dateStart = appointmentFiltersService.applyFullDateFilter(self.dateStartFilter);
            _filters.dateEnd = appointmentFiltersService.applyFullDateFilter(self.dateEndFilter);
            _filters.client = self.clientFilter;
            _filters.department = self.departmentFilter;
        }

        self.loadMoreAppointments = function () {
            self.isOtherAppointmentsLoading = true;
            _filters.offset++;
            _updateAppointmentsList(true);
        };

        function geoErrCB(err) {
            $timeout(function() {
                self.geoerror = {
                    type: 'error',
                    message: "La géolocation n'est pas disponible.",
                    cause: err
                };
            });
        }

        function _getMyposition () {
            let navigator = $window.navigator;
            if ('geolocation' in navigator) {
                navigator.geolocation.getCurrentPosition(
                    function(position) {
                        $timeout(function() {
                            self.center = {
                                lat : position.coords.latitude,
                                lng: position.coords.longitude,
                                zoom: 7
                            };
                        });
                    },
                    geoErrCB,
                    {
                        timeout: 10000
                    }
                );
            }
        }

        function _isTelepro() {
            return ['TELEPRO', 'CS', 'RESP TELEPRO', 'AC', 'DC'].indexOf($rootScope.user.role) !== -1;
        }

        function _isCSD() {
            return ['RESP CSD', 'CSD'].indexOf($rootScope.user.role) !== -1;
        }

        const APPOINTMENT_TYPES = {
            CSD: 'S',
            TELEPRO: 'P'
        };

        function _determinePurposes() {
            return (_isCSD())
                ? self.csdPurpose.filter(pur => pur.isReminder)
                : self.teleproPurpose.filter(pur => pur.isReminder);
        }

        function _loadAppointmentPurposes() {
            return Promise.all([
                appointmentService.getAppointmentPurposes(APPOINTMENT_TYPES.CSD),
                appointmentService.getAppointmentPurposes(APPOINTMENT_TYPES.TELEPRO)
            ]).then(([csdPurposes, teleproPurposes]) => {
                self.csdPurpose = csdPurposes;
                self.teleproPurpose = teleproPurposes;
                self.purposes = _determinePurposes();
                return Promise.resolve();
            });
        }


        /**
         * Initializes the module by setting up user data, filters, and loading appointments.
         * Handles error scenarios if user data or required configurations are unavailable.
         *
         * The method performs the following actions:
         * - Sets initial loading and error states.
         * - Validates the availability of user data in the global scope.
         * - Loads appointment purposes and initializes user-specific filters.
         * - Sets up and updates filters for appointments.
         * - Fetches all appointments based on the initialized filters.
         * - Handles errors and logs them during initialization.
         *
         * @return {void} This method does not return a value.
         */
        function _init() {
            self.loading = true;
            self.error = {
                error: false,
                message: ''
            };

            try {
                if (!$rootScope.userNetwork || !$rootScope.user) {
                    throw new Error('Données utilisateur non disponibles');
                }

                // Load appointment purposes for both CSD and Telepro
                _loadAppointmentPurposes()
                    .then(() => {
                    // Set user data
                    self.userNetwork = $rootScope.userNetwork;
                    self.user = $rootScope.user;
                    self.isExt = userService.isExternalUser(self.userNetwork.user);

                    // Initialize filters
                    self.rdsFilter = _generateRDSFilterForIHM();
                    _filters.rds = _generateRDSFilter();
                    _filters.purpose = _genereratePurposeFilter();

                    // Set user-specific filters if not saved
                    if(!appointmentFiltersService.saved) {
                        if (self.userNetwork.teleproReminder && self.userNetwork.teleproReminder.length) {
                            self.userNetwork.teleproReminder.map(c => c.checked = c.user.uid === self.user.uid);
                            self.teleproFilter = self.userNetwork.teleproReminder;
                        }
                        if (self.userNetwork.csReminder && self.userNetwork.csReminder.length) {
                            self.userNetwork.csReminder.map(t => t.checked = t.user.uid === self.user.uid);
                            self.csFilter = self.userNetwork.csReminder;
                        }
                        if (self.userNetwork.csdReminder && self.userNetwork.csdReminder.length) {
                            self.userNetwork.csdReminder.map(t => t.checked = t.user.uid === self.user.uid);
                            self.csdFilter = self.userNetwork.csdReminder;
                        }
                        if (self.userNetwork.formerRDSReminder && self.userNetwork.formerRDSReminder.length) {
                            self.formerRDSFilter = self.userNetwork.formerRDSReminder;
                        }
                    }

                    // Initialize and update all filters
                    appointmentFiltersService.initFiltersValues(self.networkList);
                    appointmentFiltersService.initFiltersTreatedValues(self.treated);
                    _initFiltersValues();
                    self.updateMarketFilter();
                    self.updatePurposeFilter();
                    self.updateStateFilter();
                    self.updateSupplierFilter();
                    self.updateCsFilter();
                    self.updateCsdFilter();
                    self.updateTeleproFilter();
                    self.updateFormerRDSFilter();

                    if(self.user.role !== 'RDS') {
                        self.updateRDSFilter();
                    }

                    // Load appointments
                    return appointmentService.getAllAppointments(_filters);
                })
                .then(appointments => {
                    self.appointments = appointments;
                    _setMarkers(self.appointments, true);
                })
                .catch(err => {
                    self.error = {
                        error: true,
                        message: 'Une erreur est survenue lors de l\'initialisation'
                    };
                    $log.error('Erreur dans _init:', err);
                })
                .finally(() => {
                    self.loading = false;
                });

            } catch(err) {
                self.error = {
                    error: true,
                    message: 'Une erreur est survenue lors de l\'initialisation'
                };
                $log.error('Erreur dans _init:', err);
                self.loading = false;
            }
        }
        _getMyposition();
        _initIHMFilters()
        _init();

        /** leafleft **/

        self.events = {
            map: {
                enable: ['zoomlevelschange', 'drag', 'viewreset'],
                logic: 'emit'
            }
        };

        self.controls = {
            scale: {
                metric: true,
                imperial: false
            }
        };

        // Récupération de la configuration de la position de la carte
        self.userMapCenter = self.appointments && $rootScope.userMapCenter;
        $scope.$on('leafletDirectiveMap.mapReminder.drag', function(event) {
            _saveUserMapCenter();
        });

        function _saveUserMapCenter() {
            $rootScope.userMapCenter = self.center;
        }

        function _setMarkers(appointments, updateCenter) {
            self.markers = {};
            self.markers['marker'] = {
                lat: parseFloat(self.center.lat),
                lng: parseFloat(self.center.lng),
                title: 'Votre position',
                message: 'Vous êtes ici.',
                icon: {
                    type: 'vectorMarker',
                    viewBox: '0 0 32 52',
                    iconSize: [30 * 1.15, 50 * 1.15],
                    iconAnchor: [15 * 1.1, 50 * 1.1],
                    icon: 'none', // Utilisation des icones Bimedia, mais ne doit pas être vide
                    prefix: 'none', // Utilisation des icones Bimedia, mais ne doit pas être vide
                    iconColor: '',
                    markerColor: 'red',
                    extraClasses: ''
                }
            };

            appointments.forEach(function(app, i) {
                const clientState = app.store ? app.store.etat_magasin_label : null;
                const marketNum = app.store ? app.store.stat1 : null;
                if (app.store && app.store.contact && app.store.contact.latitude && app.store.contact.longitude) {
                    self.markers['marker' + (i + 1)] = {
                        lat: parseFloat(app.store.contact.latitude),
                        lng: parseFloat(app.store.contact.longitude),
                        title: app.store.enseigne,
                        message: _formatMarkerMessage(app.store),
                        icon: {
                            type: 'vectorMarker',
                            viewBox: '0 0 32 52',
                            iconSize: [30 * 1.15, 50 * 1.15],
                            iconAnchor: [15 * 1.1, 50 * 1.1],
                            icon: 'none', // Utilisation des icones Bimedia, mais ne doit pas être vide
                            prefix: 'none', // Utilisation des icones Bimedia, mais ne doit pas être vide
                            iconColor: '',
                            markerColor: _getMarkerColor(clientState),
                            extraClasses: _getMarkerIconClass(marketNum)
                        }
                    };
                }
            });

            if (updateCenter && Object.keys(self.markers).length > 0) {
                _setMapCenter(self.markers, self.userMapCenter);
            }

            /**
             * Initializes the map position
             */
            function _setMapCenter(markers, userMapCenter) {
                if (userMapCenter) {
                    _setUserMapCenter($rootScope.userMapCenter);
                }
                else {
                    _setDefaultMapCenter(markers);
                }
            }

            /**
             * Initializes the position of the map with the user's configuration
             */
            function _setUserMapCenter(userMapCenter) {
                self.center = {
                    lat: userMapCenter.lat,
                    lng: userMapCenter.lng,
                    zoom: userMapCenter.zoom
                };
            }

            /**
             * Initializes the default position of the map
             */
            function _setDefaultMapCenter(markers) {
                let firstMarker = _getFirstMarker(markers);
                self.center = {
                    lat: firstMarker.lat,
                    lng: firstMarker.lng,
                    zoom: 7
                };
            }

            function _getMarkerColor(clientState) {
                for (let clientStateElement of self.stateOptions) {
                    if (clientStateElement.id === clientState) {
                        return clientStateElement.color;
                    }
                }
                return 'white';
            }

            function _getMarkerIconClass(marketNum) {
                let className = '';

                for (let marketElement of self.marketOptions) {
                    if (marketElement.state === marketNum) {
                        className = 'marker-market-' + marketElement.code;
                        break;
                    }
                }

                return className;
            }

            function _getFirstMarker(markers) {
                let firstKey = Object.keys(markers)[0];
                return markers[firstKey];
            }
        }

        function _formatMarkerMessage(store) {
            let message = '';
            if (store.hasOwnProperty('enseigne') && store.enseigne) {
                message += '<b>' + store.enseigne + '</b>';
            }
            if (store.hasOwnProperty('customers') && store.customers.length > 0) {
                if (message !== '') {
                    message += '<br>';
                }
                message += store.customers[0].nom_client + ' ' + store.customers[0].prenom_client;
            }
            if (store.hasOwnProperty('identifiant_magasin')) {
                message += '<br/><br/>';
                message +=
                    '<a href="#!/prospection/store/' + store.identifiant_magasin + '">Voir la fiche du point de vente</a>';
            }

            return message;
        }

        return self;
    }

    ReminderCtrl.$inject = ['$scope', '$rootScope', '$filter', '$log', '$window', '$timeout', 'appointmentService', 'appointmentFiltersService', 'userService',
        'commonService', 'fournisseurService', 'Notification', 'leafletMapEvents'];

    angular.module('app.prospection.store.reminderCtrl', ['leaflet-directive']).controller('ReminderCtrl', ReminderCtrl);
});
